import * as R from 'ramda'
import { isActionType } from 'helpers/ramda-ext/actions'
import { STATUS } from 'constants/checkout'
import * as Actions from 'store/actions'
import { RegisteredAction } from 'store/actions/index.types'
import {
  CheckoutStatusChangedAction,
  CheckoutStatusChangedActionPayload,
  CheckoutStatusChangedProcessStatuses
} from 'store/actions/checkout.types'
import { InitialState, State } from './checkout.types'

const initialState: InitialState = {
  checkoutDisabled: false,
  redirectBody: null,
  redirectTo: null,
  requestId: null,
  secondsWaitingTime: null,
  status: STATUS.NOT_STARTED
}

const setStatus = R.assoc('status')

const setCheckoutRedirection = (status: CheckoutStatusChangedProcessStatuses, response): State => ({
  checkoutDisabled: response.checkoutDisabled,
  redirectBody: response.dataToPost,
  redirectTo: response.redirectTo,
  requestId: response.requestId,
  secondsWaitingTime: response.secondsBeforeRedirection,
  status
})

// eslint-disable-next-line @typescript-eslint/default-param-last
export default (state: State = initialState, action: RegisteredAction): State => R.cond([
  [
    isActionType(Actions.checkout.CHECKOUT_RESET),
    R.always(initialState)
  ], [
    isActionType(Actions.checkout.CHECKOUT_STATUS_CHANGED),
    (a: CheckoutStatusChangedAction) => {
      const { response, status } = a.payload as CheckoutStatusChangedActionPayload

      return response !== undefined
        ? setCheckoutRedirection(status, response)
        : setStatus(status, state)
    }
  ], [
    R.T,
    R.always(state)
  ]
])(action)
